import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import Menu from "./components/menu";
import Submenu from "./components/submenu";
import Resultados from "./components/resultados";
import SuperTime from "./pages/super-time";

import { useDispatch } from "react-redux";
import ConcursoInput from "../concurso/concursoInput";
import Loteria from "../loteria/loteria";
import { selectConcursoType } from "../reducers/concurso/concursoActions";

import TimeCertoDefault from "src/static/tutorial/time-certo/default";

import Rifa from "src/rifa/rifa";
import Messages from "src/common/msg/messages";
import { getConcursoTutorial } from "../static/tutorial/concurso";
import Cotacoes from "./components/cotacoes";
import PreTicketList from "../rifa/components/preTicketList";

import Apostas from "../relatorios/suasapostas";

import { connect } from "react-redux";
import { getTutorialLotPop } from "../static/tutorial/helper";
import { saveState } from "../modules/localStorage";

function NewApp(props) {
  require("src/common/themes/default.scss");
  require("./utils/iframeResizer.contentWindow.min.js");
  const {
    sendWindowsContentHeight,
  } = require("./utils/sendWindowsContentHeight.js");
  sendWindowsContentHeight();
  // const arrApostas = useSelector((state) => state.carrinho.arrApostas);
  const dispath = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const showQuotation = params.get("quotation") === 'true';

  const submenuRef = useRef(null);

  const [selectedContest, setSelectedContest] = useState(null);
  const [currentPage, setCurrentPage] = useState("Apostar");

  const [section, setSection] = useState("");

  useEffect(() => {
    setCurrentPage("Apostar");
  }, [selectedContest]);

  useEffect(() => {
    setCurrentPage("Apostar");
  }, []);

  useLayoutEffect(() => {
    const params = new URL(document.location.href).searchParams;
    const sectionName = params.get("section");

    if (sectionName) {
      setSection(sectionName);
    }
  }, []);

  useEffect(() => {
    if (submenuRef && submenuRef.current) {
      submenuRef.current.reset();
    }
  }, [submenuRef, selectedContest]);

  const selectContest = (contest) => {
    saveState(contest, "contest");
    setSelectedContest(contest);
    if (contest && !contest.isPreTickets) {
      dispath(selectConcursoType(contest));
    }
  };

  const RenderSelectedContest = useCallback(() => {    
    if (!selectedContest) {
      return <React.Fragment></React.Fragment>;
    }

    if (selectedContest.isPreTickets) {
      return <PreTicketList toggleErrorModal={props.toggleErrorModal} user={props.objUser} />
    }

    if (selectedContest.isMinhasApostas) {
      return <Apostas toggleErrorModal={props.toggleErrorModal} hideBackButton topRef={props.topRef}/>
    }

    if (selectedContest.type === "super-time") {
      return <SuperTime 
      toggleErrorModal={props.toggleErrorModal} 
      selectedContest={selectedContest} 
      topRef={props.topRef} />;
    }

    if (selectedContest.type === "loteria-popular") {
      return <Loteria 
                toggleErrorModal={props.toggleErrorModal}
              />;
    }
    if (selectedContest.type === "rifa") {
      return <Rifa toggleErrorModal={props.toggleErrorModal}/>;
    } else {
      return <ConcursoInput 
      toggleErrorModal={props.toggleErrorModal} 
      concursoType={selectedContest} 
      topRef={props.topRef} />;
    }
  }, [selectedContest]);

  const RenderContestTutorial = useCallback(({ selectedContest }) => {
    if (selectedContest.type === "loteria-popular") {
      return getTutorialLotPop();
    }

    if (selectedContest.type === "super-time") {
      return (
        <TimeCertoDefault
        toggleErrorModal={props.toggleErrorModal} 
          name={selectedContest.objTipoJogo.vchNome.toUpperCase()}
        />
      );
    }

    if (selectedContest.type === "concurso") {
      return getConcursoTutorial(selectedContest);
    }

    return <React.Fragment />;
  }, []);

  return (
    <React.Fragment>
      <Menu setSelectedContest={selectContest} defaultSelection={section} hidden={!!section} />
      <div ref={props.topRef} id="topRef"></div>
      {!!selectedContest && (
        <React.Fragment>
          {/* <div className="banner"></div> */}

          {selectedContest.submenu && selectedContest.submenu.length !== 1 && selectedContest.type !== "rifa" && (
            <Submenu
              onChange={setCurrentPage}
              submenu={selectedContest.submenu}
              ref={(node) => {
                submenuRef.current = node;
              }}
            />
          )}

          {currentPage === "Apostar" && (
            <div className="new-app-body">
              <RenderSelectedContest />
            </div>
          )}

          {currentPage === "Como jogar" && (
            <div className="new-app-body">
              <RenderContestTutorial selectedContest={selectedContest} />
            </div>
          )}

          {currentPage === "Cotações" && showQuotation && (
            <div className="new-app-body">
              <Cotacoes selectedContest={selectedContest} />
            </div>
          )}

          {currentPage === "Resultados" && (
            <div className="new-app-body">
              <Resultados
                selectedContest={selectedContest}
                type={selectedContest.type}
              />
            </div>
          )}
        </React.Fragment>
      )}
      <Messages />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({ objUser: state.usuario.objUser });
export default connect(mapStateToProps)(NewApp);



// WEBPACK FOOTER //
// ./src/newDesign/newApp.jsx